.premium-programs-cell {
  display: flex;
  align-items: center;
  height: 100%;
}
